import { ListItem } from "@mui/material";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import "./NavBar.scss";

const NavItem = ({ path, Icon, listVariant }) => {
  const location = useLocation();
  return (
    <ListItem component={motion.li} variants={listVariant}>
      <Link
        to={path}
        className={location.pathname === path ? `navLink active` : `navLink`}
      >
        {Icon}
      </Link>
    </ListItem>
  );
};

export default NavItem;
